import { useState } from "react";
import useCloudinaryUpload from "./useCloudinaryUpload";

export const useUploadInput = ({
  cloudinaryContext,
  folderName,
  emitNewImageUpload,
  handlePostAssetsUpload,
  isLogo = false
}) => {
  const [dragging, setDragging] = useState(false);
  const { emitCloudinaryUpload, uploading } = useCloudinaryUpload();

  const handleFiles = (files) => {
    if (!files || files.length === 0) return;

    Array.from(files).forEach((file) => {
      emitCloudinaryUpload(
        { target: { files: [file] } },
        {
          image: "",
          handlePictureChanged: (data) => emitNewImageUpload(data?.url),
          allowVideos: true,
          allowImages: true,
          fileTypes: [],
          context: cloudinaryContext,
          folderName,
          isLogo,
          type: "Upload"
        }
      );
    });
    if (handlePostAssetsUpload) handlePostAssetsUpload();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => setDragging(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    handleFiles(e.dataTransfer.files);
  };

  const handleInputChange = (e) => {
    handleFiles(e.target.files);
  };

  return {
    dragging,
    uploading,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleInputChange
  };
};
